import { render, staticRenderFns } from "./InternetPlansTableHead.vue?vue&type=template&id=6804749a&scoped=true&"
import script from "./InternetPlansTableHead.vue?vue&type=script&lang=js&"
export * from "./InternetPlansTableHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6804749a",
  null
  
)

export default component.exports